<template lang="pug">
  b-row.mb-5
    b-col
      router-view(@contact-changed='reloadAccountsPanel')
</template>

<script>
export default {
  name: 'manager-accounts-contact',
  methods: {
    reloadAccountsPanel() {
      this.$parent.$refs.accountsPanel.panelReload()
    },
  },
}
</script>
